module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"webhook_settings":"Webhook Settings","trigger_when":"Trigger when","webhook_url":"Webhook URL"},"id":{"webhook_settings":"Peraturan Webhook","trigger_when":"Aktifkan ketika","webhook_url":"Webhook URL"}}')
  delete Component.options._Ctor
}
